module.exports = new __parcel__URL__("battlepass_explore_button.2e737067.png").toString();